import { render, staticRenderFns } from "./FooterSocialMedia.vue?vue&type=template&id=05230942&scoped=true&"
import script from "./FooterSocialMedia.vue?vue&type=script&lang=js&"
export * from "./FooterSocialMedia.vue?vue&type=script&lang=js&"
import style0 from "./FooterSocialMedia.vue?vue&type=style&index=0&id=05230942&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05230942",
  null
  
)

export default component.exports